import { render, staticRenderFns } from "./dictionaryDetailModal.vue?vue&type=template&id=54f0cee4"
import script from "./dictionaryDetailModal.vue?vue&type=script&lang=js"
export * from "./dictionaryDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports